							// Adiciona número do cabo no topo
							const caboNome = caboDados[0].cabo;
							const canvasCabo = document.createElement('canvas');
							canvasCabo.width = 128;
							canvasCabo.height = 64;
							const ctxCabo = canvasCabo.getContext('2d');
							ctxCabo.font = 'bold 32px Arial';
							ctxCabo.fillStyle = '#fff';
							ctxCabo.textAlign = 'center';
							ctxCabo.textBaseline = 'middle';
							ctxCabo.fillText(caboNome, canvasCabo.width / 2, canvasCabo.height / 2);
							const textureCabo = new THREE.CanvasTexture(canvasCabo);
							const caboSpriteMaterial = new THREE.SpriteMaterial({ map: textureCabo, depthTest: false, transparent: true });
							const caboSprite = new THREE.Sprite(caboSpriteMaterial);
							// Posição: topo do cabo
							caboSprite.position.set(x, yTopoCabo + 0.13, z);
							caboSprite.scale.set(0.18, 0.09, 1);
							arcoGrupo.add(caboSprite);
<template>
	<div id="app">
		<div class="row m-1 d-flex">
			<div class="botao d-flex justify-content-center">
				<button class="btn btn-success" @click="resetSilo">Voltar modelo 3D à posição inicial</button>
			</div>
			<div class="checkbox-arcos arco-scroll-vertical">
				<button class="botaoinfo" @click="exibirDicas">
					<i class="fas fa-info-circle"></i>
				</button>
				<div class="m-2" v-for="(arco, index) in arcosExistentes" :key="index">
					<input type="checkbox" :id="'arco-' + arco" v-model="arcosVisiveis[arco]" @change="toggleArco(arco)">
					<label :for="'arco-' + arco">Arco {{ arco }}</label>
				</div>
				<div class="m-2" v-if="possuiCaboCentral">
					<input type="checkbox" id="cabo-central" v-model="caboCentralVisivel" @change="toggleCaboCentral">
					<label for="cabo-central">Cabo Central</label>
				</div>
				<div class="m-2">
					<input type="checkbox" id="nivel" v-model="nivelVisivel" @change="toggleNivel">
					<label for="nivel">Nível</label>
				</div>
			</div>
		</div>
		<div class="overlay" v-if="abaDicas"></div>
		<div class="card dicas-popup" v-if="abaDicas">
			<div class="dicas card-body">
				<h3 class="card-title">Como usar:</h3>
				<p class="card-text dicas-text"><strong>Botão esquerdo do mouse:</strong> Gira o silo no seu próprio eixo</p>
				<p class="card-text dicas-text"><strong>Botão direito do mouse:</strong> arrasta o silo para os lados</p>
				<p class="card-text dicas-text"><strong>Scroll do mouse (roda):</strong> Aproxima e afasta o silo</p>
				<p class="card-text dicas-text"><strong>Dica:</strong> Caso perca o silo de vista ou coloque-o numa posição difícil de enxergar, aperte o botão <strong class="badge rounded-pill bg-success">Voltar modelo 3D à posição inicial</strong></p>
				&nbsp;
				<button class="btn btn-success" @click="abaDicas = false">Fechar</button>
			</div>
		</div>
		<canvas id="scene"></canvas>
	</div>
</template>

<script>
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
import { useToast } from 'vue-toastification';
import temperaturaCores from "@/assets/colors.json";

export default {
	name: 'Silo3dComponent',
	props: {
		termometria: {
			type: Object,
			default: () => ({}),
		},
		silo: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			arcosVisiveis: {},
			arcosExistentes: [],
			caboCentralVisivel: true,
			possuiCaboCentral: false,
			nivelVisivel: true,
			abaDicas: false,
			caboCentral: [],
			textMeshes: [],
			caboCentralTextMeshes: []
		};
	},
	watch: {
		silo: {
			handler() {
				window.location.reload();
			},
			deep: true
		}
	},
	mounted() {
		const toast = useToast();
		try {
			this.arcosExistentes = [...new Set(this.silo.cabos.map(cabo => cabo.arco))].filter(arco => arco !== 999);
			this.arcosExistentes.forEach(arco => {
				this.arcosVisiveis[arco] = true;
			});
			this.possuiCaboCentral = this.silo.cabos.some(cabo => cabo.arco === 999);
			this.initThreeJS();
		} catch (e) {
			toast.error('Erro ao gerar silo 3D');
			console.error(e);
		}
	},
	methods: {
		async initThreeJS() {
			const poligonos = 16;
			const corsilo = 0x808080;
			const raioAumentado = 1.7;

			// INICIO RENDER
			this.cenario = new THREE.Scene();
			this.cenario.background = new THREE.Color(0x909090);
			this.camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 1000);
			this.renderer = new THREE.WebGLRenderer({ canvas: document.getElementById('scene') });
			this.renderer.setSize(window.innerWidth, window.innerHeight);

			// const pisoCor = 0x505050;
			// const pisoGeometry = new THREE.PlaneGeometry(190, 190);
			// const pisoMaterial = new THREE.MeshStandardMaterial({ color: pisoCor, side: THREE.DoubleSide });
			// const piso = new THREE.Mesh(pisoGeometry, pisoMaterial);
			// piso.rotation.x = -Math.PI / 2;
			// piso.position.y = -1; // base do silo
			// piso.receiveShadow = false;
			// this.cenario.add(piso);

			if (this.silo.tipo === "silo") {

				// GRUPO DO SILO
				this.siloGroup = new THREE.Group();
	
				// CILINDRO (SILO)
				const cilindroSiloGeometria = new THREE.CylinderGeometry(raioAumentado, raioAumentado, 2, poligonos, 1, true);
				const cilindroSiloMaterial = new THREE.MeshStandardMaterial({ color: corsilo, opacity: 0.5, transparent: true });
				this.cylinder = new THREE.Mesh(cilindroSiloGeometria, cilindroSiloMaterial);
				this.cylinder.renderOrder = 2;
				this.siloGroup.add(this.cylinder);
	
				// CONE (SILO)
				const coneSiloGeometria = new THREE.ConeGeometry(raioAumentado, 0.65, poligonos, 1, true);
				const coneSiloMaterial = new THREE.MeshStandardMaterial({ color: corsilo, opacity: 0.5, transparent: true });
				const cone = new THREE.Mesh(coneSiloGeometria, coneSiloMaterial);
				cone.position.y = 1.325;
				cone.renderOrder = 2;
				this.siloGroup.add(cone);
	
				// CAMADA AMARELA (nível)
				const nivelMap = [
					{ max: 5, nivel: 0.04 },
					{ max: 11, nivel: 0.05 },
					{ max: 21, nivel: 0.2 },
					{ max: 30, nivel: 0.5 },
					{ max: 41, nivel: 0.7 },
					{ max: 51, nivel: 1 },
					{ max: 61, nivel: 1.2 },
					{ max: 71, nivel: 1.4 },
					{ max: 81, nivel: 1.6 },
					{ max: 91, nivel: 1.8 },
					{ max: 101, nivel: 2 }
				];
				const nivel = nivelMap.find(n => (this.silo.tipo_nivel == 1 ? this.silo.nivel_automatico : this.silo.nivel_manual) < n.max).nivel;
				const varianivel = -0.01 + 0.5 * (nivel - 2);
				const haTopoGrao = (nivel >= 0.05);
				const cilindroNivelGeometria = new THREE.CylinderGeometry(raioAumentado - 0.01, raioAumentado - 0.01, nivel, poligonos, 1, haTopoGrao);
				const cilindroNivelMaterial = new THREE.MeshStandardMaterial({ color: 0xFFFF00, opacity: 0.5, transparent: true });
				this.sand = new THREE.Mesh(cilindroNivelGeometria, cilindroNivelMaterial);
				this.sand.position.y = varianivel;
				this.sand.renderOrder = 1;
				this.siloGroup.add(this.sand);
	
				// CONE AMARELO (nível)
				if (nivel >= 0.05) {
					const coneNivelGeometria = new THREE.ConeGeometry(raioAumentado - 0.01, 0.65, poligonos, 1, true);
					const coneNivelMaterial = new THREE.MeshStandardMaterial({ color: 0xFFFF00, opacity: 0.5, transparent: true });
					this.coneNivel = new THREE.Mesh(coneNivelGeometria, coneNivelMaterial);
					this.coneNivel.position.y = varianivel + nivel / 2 + 0.325;
					this.coneNivel.renderOrder = 1;
					this.siloGroup.add(this.coneNivel);
				}
	
				// MATERIAL DOS CABOS
				const caboMaterial = new THREE.LineBasicMaterial({ color: 0xffffff });
				const caboGeometry = new THREE.BufferGeometry().setFromPoints([
					new THREE.Vector3(0, -1, 0),
					new THREE.Vector3(0, 1.5, 0)
				]);
				this.caboPendulo = new THREE.Line(caboGeometry, caboMaterial);
				this.siloGroup.add(this.caboPendulo);
	
				// SENSORES
				const sensorGeometria = new THREE.SphereGeometry(0.03, 8, poligonos);
	
				const arcMaterial = new THREE.LineBasicMaterial({ color: 0xffffff });
	
				// FUNÇAO P USAR P CRIAR ARCOS
				const criarArco = (raioArco, caboPorArco, arco, cabos) => {
					const arcoGrupo = new THREE.Group();
					arcoGrupo.name = `arco-${arco}`;
					const comprimentoCabo = 2.47 - (raioArco * 0.5);
					for (let i = 0; i < caboPorArco; i++) {
						let cabo = cabos[caboPorArco - 1 - i];
						let caboDados = (this.termometria.dados.filter(dado => dado.cabo === cabo.cabo));
						if (caboDados.length === 1) {
	
							const angle = (i / caboPorArco) * Math.PI * 2;
							const x = raioArco * Math.cos(angle);
							const z = raioArco * Math.sin(angle);
							const arcGeometry = new THREE.BufferGeometry().setFromPoints([
								new THREE.Vector3(x, -1, z),
								new THREE.Vector3(x, -1 + comprimentoCabo, z)
							]);
							const arcLine = new THREE.Line(arcGeometry, arcMaterial);
							arcoGrupo.add(arcLine);
	
							for (let j = 0; j < cabo.sensores; j++) {	
								let sensorCor = this.getCorPorTemperatura(caboDados[0].temperaturas[`s${j + 1}`]) || 0xffffff;
								const sensorMaterial = new THREE.MeshBasicMaterial({ color: sensorCor });
								const sensor = new THREE.Mesh(sensorGeometria, sensorMaterial);
								sensor.position.set(x, -1 + (comprimentoCabo / (cabo.sensores - 1)) * j, z);
								sensor.userData = { temperatura: caboDados[0].temperaturas[`s${j + 1}`]};
								arcoGrupo.add(sensor);
		
								const loader = new FontLoader();
								loader.load('/fonts/helvetiker_regular.typeface.json', (font) => {
									const caboTemp = (caboDados[0].temperaturas[`s${j + 1}`] < 99 ? caboDados[0].temperaturas[`s${j + 1}`] : 'OFF');
									const numeroTemp = new TextGeometry(`${caboTemp}`, {
										font: font,
										size: 0.05,
										depth: 0.01,
									});
									const numeroMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff });
									const textMesh = new THREE.Mesh(numeroTemp, numeroMaterial);
									textMesh.position.set(x, -1 + (comprimentoCabo / (cabo.sensores - 1)) * j + 0.05, z);
									arcoGrupo.add(textMesh);
									this.textMeshes.push(textMesh);
								});
							}
		
							const loader = new FontLoader();
							loader.load('/fonts/helvetiker_regular.typeface.json', (font) => {
								let caboNome = caboDados[0].cabo;
								const numeroCabo = new TextGeometry(`${caboNome}`, {
									font: font,
									size: 0.11,
									depth: 0.01,
								});
								numeroCabo.computeBoundingBox();
								const centerOffset = -0.5 * (numeroCabo.boundingBox.max.x - numeroCabo.boundingBox.min.x);
								numeroCabo.translate(centerOffset, 0, 0);
								const numeroMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff });
								const textMesh = new THREE.Mesh(numeroCabo, numeroMaterial);
								textMesh.position.set(x, -0.8 + comprimentoCabo + 0.1, z);
								arcoGrupo.add(textMesh);
								this.textMeshes.push(textMesh);
							});
						}
					}
					this.siloGroup.add(arcoGrupo);
				};
	
				// ARCOS
				const raioArcoMap = {
					1: [raioAumentado * 0.5],
					2: [raioAumentado * 0.8, raioAumentado * 0.4],
					3: [raioAumentado * 0.75, raioAumentado * 0.5, raioAumentado * 0.25],
					4: [raioAumentado * 0.8, raioAumentado * 0.6, raioAumentado * 0.4, raioAumentado * 0.2],
					5: [raioAumentado * 0.831, raioAumentado * 0.653, raioAumentado * 0.499, raioAumentado * 0.333, raioAumentado * 0.166]
				};
	
				this.arcosExistentes.forEach((arco, index) => {
					const caboPorArco = this.silo.cabos.filter(cabo => cabo.arco === arco).length;
					const raioArco = raioArcoMap[this.arcosExistentes.length][index];
					const cabos = this.silo.cabos
						.filter(cabo => cabo.arco === arco)
						.sort((a, b) => (a.posicao ?? 0) - (b.posicao ?? 0));
					criarArco(raioArco, caboPorArco, arco, cabos);
				});
	
				// CABO CENTRAL
				const possuiCaboCentral = this.silo.cabos.some(cabo => cabo.arco === 999);
				if (!possuiCaboCentral) {
					this.caboPendulo.visible = false;
				} else {
					const sensoresCaboCentral = this.termometria.dados[this.termometria.dados.length - 1].sensores;
					const temperaturasCaboCentral = this.termometria.dados[this.termometria.dados.length - 1].temperaturas;
	
					for (let i = 0; i < sensoresCaboCentral; i++) {
						let sensorCor = this.getCorPorTemperatura(temperaturasCaboCentral[`s${i + 1}`]) || 0xffffff;
						const sensorMaterial = new THREE.MeshBasicMaterial({ color: sensorCor });
						const sensor = new THREE.Mesh(sensorGeometria, sensorMaterial);
						sensor.position.set(0, -1 + (2.5 / (sensoresCaboCentral - 1)) * i, 0);
						this.siloGroup.add(sensor);
						this.caboCentral.push(sensor);
	
						const loader = new FontLoader();
						loader.load('/fonts/helvetiker_regular.typeface.json', (font) => {
							const sensorTemp = (temperaturasCaboCentral[`s${i + 1}`] < 99 ? temperaturasCaboCentral[`s${i + 1}`] : 'OFF');
							const numeroTemp = new TextGeometry(`${sensorTemp}`, {
								font: font,
								size: 0.05,
								depth: 0.01,
							});
							const numeroMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff });
							const textMesh = new THREE.Mesh(numeroTemp, numeroMaterial);
							textMesh.position.set(0, -1 + (2.5 / (sensoresCaboCentral - 1)) * i + 0.05, 0);
							this.siloGroup.add(textMesh);
							this.caboCentralTextMeshes.push(textMesh);
						});
					}
				}
	
				// ADICIONANDO O GRUPO DO SILO À CENA
				this.cenario.add(this.siloGroup);
			} else {
				this.siloGroup = new THREE.Group();
				
				const numArcos = this.arcosExistentes.length;
				const escalaArmazem = 1.7;
				const largura = 3.5 * escalaArmazem;
				const altura = 0.5 * escalaArmazem;
				const profundidade = Math.max(1, numArcos * 0.4) * escalaArmazem;
				const boxGeometry = new THREE.BoxGeometry(largura, altura, profundidade);
				const boxMaterial = new THREE.MeshStandardMaterial({ color: corsilo, opacity: 0.5, transparent: true });
				const warehouse = new THREE.Mesh(boxGeometry, boxMaterial);
				warehouse.position.y = altura / 2 - 1;
				this.siloGroup.add(warehouse);

				// telhado prisma triangular (duas águas)
				// Altura do telhado para ângulo de 30 graus nas bases
				const anguloBaseRad = Math.PI / 6; // 30 graus em radianos
				const telhadoAltura = (largura / 2) * Math.tan(anguloBaseRad);
				const yBase = warehouse.position.y + altura / 2;
				// Vértices: base do retângulo + topo central
				const v1 = [-largura/2, yBase, -profundidade/2]; // canto esquerdo frente
				const v2 = [largura/2, yBase, -profundidade/2];  // canto direito frente
				const v3 = [largura/2, yBase, profundidade/2];   // canto direito trás
				const v4 = [-largura/2, yBase, profundidade/2];  // canto esquerdo trás
				const v5 = [0, yBase + telhadoAltura, -profundidade/2]; // topo frente
				const v6 = [0, yBase + telhadoAltura, profundidade/2];  // topo trás

				// Faces: apenas lados do telhado, sem base (topo invisível)
				const verts = [].concat(
					// Face esquerda
					v1, v4, v6,
					v1, v6, v5,
					// Face direita
					v2, v5, v6,
					v2, v6, v3
				);
				const telhadoGeometry = new THREE.BufferGeometry();
				telhadoGeometry.setAttribute('position', new THREE.Float32BufferAttribute(verts, 3));
				telhadoGeometry.computeVertexNormals();
				const telhadoMaterial = new THREE.MeshStandardMaterial({ color: corsilo, opacity: 0.5, transparent: true });
				const telhado = new THREE.Mesh(telhadoGeometry, telhadoMaterial);
				this.siloGroup.add(telhado);

				// Laterais do telhado (frente e trás)
				const lateralMaterial = new THREE.MeshStandardMaterial({ color: corsilo, opacity: 0.5, transparent: true, side: THREE.DoubleSide });
				// Frente
				const lateralFrenteGeometry = new THREE.BufferGeometry();
				lateralFrenteGeometry.setAttribute('position', new THREE.Float32BufferAttribute([
					-largura/2, yBase, -profundidade/2,
					largura/2, yBase, -profundidade/2,
					0, yBase + telhadoAltura, -profundidade/2
				], 3));
				lateralFrenteGeometry.computeVertexNormals();
				const lateralFrente = new THREE.Mesh(lateralFrenteGeometry, lateralMaterial);
				this.siloGroup.add(lateralFrente);
				// Trás
				const lateralTrasGeometry = new THREE.BufferGeometry();
				lateralTrasGeometry.setAttribute('position', new THREE.Float32BufferAttribute([
					-largura/2, yBase, profundidade/2,
					largura/2, yBase, profundidade/2,
					0, yBase + telhadoAltura, profundidade/2
				], 3));
				lateralTrasGeometry.computeVertexNormals();
				const lateralTras = new THREE.Mesh(lateralTrasGeometry, lateralMaterial);
				this.siloGroup.add(lateralTras);

				// SENSORES E CABOS EM FILEIRAS
				const arcMaterial = new THREE.LineBasicMaterial({ color: 0xffffff });
				const fileiraEspaco = profundidade / (numArcos + 2.5); // diminui o espaçamento entre arcos
				// Descobrir o maior número de sensores entre todos os cabos de todos os arcos
				const totalSensoresGlobal = Math.max(...this.silo.cabos.map(c => c.sensores));
				const numPosicoes = 9;
				const posicoesX = Array.from({ length: numPosicoes }, (_, i) => -largura / 2 + ((i + 1) * largura) / (numPosicoes + 1));
				this.arcosExistentes.forEach((arco, arcoIdx) => {
					const cabos = this.silo.cabos.filter(cabo => cabo.arco === arco);
					const z = -profundidade / 2 + fileiraEspaco * (arcoIdx + 1);
					const arcoGrupo = new THREE.Group();
					arcoGrupo.name = `arco-${arco}`;

					// Quadrado (linha retangular) para simular arco
					if (cabos.length > 0) {
						const arcoMaterial = new THREE.LineBasicMaterial({ color: 0x333333, linewidth: 2 });
						const xMin = -largura / 2;
						const xMax = largura / 2;
						const yBase = warehouse.position.y - altura / 2;
						const yTopo = warehouse.position.y + altura / 2;
						// Retângulo sem o topo (apenas base e laterais)
						const pontosRetangulo = [
							new THREE.Vector3(xMin, yBase, z),
							new THREE.Vector3(xMax, yBase, z),
							new THREE.Vector3(xMax, yTopo, z),
							new THREE.Vector3(xMin, yTopo, z)
						];
						const arcoGeometry = new THREE.BufferGeometry().setFromPoints(pontosRetangulo);
						const arcoLine = new THREE.Line(arcoGeometry, arcoMaterial);
						arcoGrupo.add(arcoLine);
					}

					cabos.forEach((cabo) => {
						let caboDados = Array.isArray(this.termometria.dados) ? this.termometria.dados.filter(dado => dado.cabo === cabo.cabo) : [];
						if (caboDados.length === 1) {
							let pos = parseInt(cabo.posicao);
							if (isNaN(pos) || pos < 1 || pos > 9) return;
							const x = posicoesX[pos - 1];
							const comprimentoCaboPadrao = altura * 0.9;
							const avancarTelhado = 0.45;
							const comprimentoCabo = comprimentoCaboPadrao * (cabo.sensores / totalSensoresGlobal);
							const yMax = warehouse.position.y + altura / 2 + avancarTelhado - 0.03;
							const yTopoCabo = Math.min(warehouse.position.y + altura / 2 + avancarTelhado, yMax);
							const yBaseCabo = warehouse.position.y - altura / 2 + (comprimentoCaboPadrao - comprimentoCabo);
							// Linha do cabo
							const arcGeometry = new THREE.BufferGeometry().setFromPoints([
								new THREE.Vector3(x, yTopoCabo, z),
								new THREE.Vector3(x, yBaseCabo, z)
							]);
							const arcLine = new THREE.Line(arcGeometry, arcMaterial);
							arcoGrupo.add(arcLine);

							// Adiciona número do cabo no topo como Sprite
							const caboNome = caboDados[0].cabo;
							const canvasCabo = document.createElement('canvas');
							canvasCabo.width = 128;
							canvasCabo.height = 64;
							const ctxCabo = canvasCabo.getContext('2d');
							ctxCabo.font = 'bold 32px Arial';
							ctxCabo.fillStyle = '#fff';
							ctxCabo.textAlign = 'center';
							ctxCabo.textBaseline = 'middle';
							ctxCabo.fillText(caboNome, canvasCabo.width / 2, canvasCabo.height / 2);
							const textureCabo = new THREE.CanvasTexture(canvasCabo);
							const caboSpriteMaterial = new THREE.SpriteMaterial({ map: textureCabo, depthTest: false, transparent: true });
							const caboSprite = new THREE.Sprite(caboSpriteMaterial);
							caboSprite.position.set(x, yTopoCabo + 0.13, z);
							caboSprite.scale.set(0.18, 0.09, 1);
							arcoGrupo.add(caboSprite);

							// Sensores 2D: Sprite
							for (let j = 0; j < cabo.sensores; j++) {
								let sensorCor = this.getCorPorTemperatura(caboDados[0].temperaturas[`s${j + 1}`]) || 0xffffff;
								const spriteMaterial = new THREE.SpriteMaterial({ color: sensorCor, depthTest: false, transparent: true });
								const sensorSprite = new THREE.Sprite(spriteMaterial);
								const comprimentoTotal = comprimentoCaboPadrao + avancarTelhado;
								let y = warehouse.position.y - altura / 2 + (comprimentoTotal / (totalSensoresGlobal - 1)) * j;
								const yMax = warehouse.position.y + altura / 2 + avancarTelhado - 0.03;
								if (y > yMax) y = yMax;
								sensorSprite.position.set(x, y, z);
								sensorSprite.scale.set(0.08, 0.08, 1);
								arcoGrupo.add(sensorSprite);
								// Adiciona número da temperatura como Sprite
								const tempValue = caboDados[0].temperaturas[`s${j + 1}`] < 99 ? caboDados[0].temperaturas[`s${j + 1}`] : 'OFF';
								const canvas = document.createElement('canvas');
								canvas.width = 128;
								canvas.height = 64;
								const ctx = canvas.getContext('2d');
								ctx.font = 'bold 52px Arial';
								ctx.fillStyle = '#fff';
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillText(tempValue, canvas.width / 2, canvas.height / 2);
								const texture = new THREE.CanvasTexture(canvas);
								const textSpriteMaterial = new THREE.SpriteMaterial({ map: texture, depthTest: false, transparent: true });
								const textSprite = new THREE.Sprite(textSpriteMaterial);
								textSprite.position.set(x, y + 0.07, z);
								textSprite.scale.set(0.13, 0.07, 1);
								arcoGrupo.add(textSprite);
							}
						}
					});
					this.siloGroup.add(arcoGrupo);
				});
				// Adiciona grupo do armazém à cena
				this.cenario.add(this.siloGroup);
			}


			// CAMERA
			this.camera.position.set(10, 3, 1);

			// CONTROLES
			this.controles = new OrbitControls(this.camera, this.renderer.domElement);
			this.controles.enableZoom = true;
			this.controles.minDistance = 3;
			this.controles.maxDistance = 17;
			this.controles.minPolarAngle = 0;
			this.controles.maxPolarAngle = Math.PI / 2.1;

			// AMBIENTAÇÃO
			const luzDirecional = new THREE.DirectionalLight(0xffffff, 1);
			luzDirecional.position.set(5, 5, 5);
			this.cenario.add(luzDirecional);

			const luzAmbiente = new THREE.AmbientLight(0xffffff);
			this.cenario.add(luzAmbiente);

			// RENDERIZAÇÃO
			const numeroSegueCamera = () => {
				requestAnimationFrame(numeroSegueCamera);

				this.controles.update();

				this.textMeshes.forEach(textMesh => {
					textMesh.lookAt(this.camera.position);
				});

				this.caboCentralTextMeshes.forEach(textMesh => {
					textMesh.lookAt(this.camera.position);
				});

				this.renderer.render(this.cenario, this.camera);
			};

			numeroSegueCamera();
		},

		// TOGGLES PARA VISIBILIDADE DOS ELEMENTOS
		toggleArco(arco) {
			const arcoGrupo = this.siloGroup.getObjectByName(`arco-${arco}`);
			if (arcoGrupo) {
				arcoGrupo.visible = this.arcosVisiveis[arco];
			}
		},
		toggleCaboCentral() {
			this.caboPendulo.visible = this.caboCentralVisivel;
			this.caboCentral.forEach(sensor => {
				sensor.visible = this.caboCentralVisivel;
			});
			this.caboCentralTextMeshes.forEach(textMesh => {
				textMesh.visible = this.caboCentralVisivel;
			});
		},
		toggleNivel() {
			this.sand.visible = this.nivelVisivel;
			this.coneNivel.visible = this.nivelVisivel;
		},

		// RESETA POSIÇÃO DA CÂMERA
		resetSilo() {
			this.camera.position.set(0, 3, 5);
			this.controles.reset();
		},

		exibirDicas() {
			this.abaDicas = true;
		},

        getCorPorTemperatura(temp) {
            temp = Number(temp);

            const faixas = Object.keys(temperaturaCores)
                .map(Number)
                .sort((a, b) => a - b);            

            for (let i = 0; i <= faixas.length - 1; i++) {
                if (temp <= faixas[i]) {
                    return temperaturaCores[faixas[i]];
                }
            }

            return "#ffffffcc";
        }
	}
};
</script>

<style scoped>
#scene {
	display: block;
	height: 57vh !important;
	width: 100% !important;
	cursor: grab;
}

.botao {
	justify-content: center;
}

.arco-scroll-vertical {
	max-height: 20vh;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	scrollbar-width: thin;
	scrollbar-color: #888 #eee;
	box-sizing: border-box;
}
.arco-scroll-vertical::-webkit-scrollbar {
	width: 8px;
}
.arco-scroll-vertical::-webkit-scrollbar-thumb {
	background: #888;
	border-radius: 4px;
}
.arco-scroll-vertical::-webkit-scrollbar-track {
	background: #eee;
}

.overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 999;
}

.dicas-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30%;
	max-height: 80%;
	overflow-y: auto;    
	background-color: rgba(255, 255, 255, 1);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1vh;
	box-shadow: 10px 10px 50px black;
}

.dicas {
	text-align: center;
	flex-direction: column;
	display: flex;
	align-items: center;
	justify-content: center;
}

.botaoinfo{
	background-color: transparent;
	border: none;
	box-shadow: none;
}

@media (max-width: 768px) {
	.dicas-popup {
		width: 80%;
		height: 50%;
	}
	.botao, .checkbox-arcos {
		flex-direction: column;
		align-items: center;
	}
	.botao button, .checkbox-arcos button {
		width: 100%;
		margin-bottom: 10px;
	}
}

@media (max-width: 480px) {
	.dicas-popup {
		width: 90%;
		height: 60%;
	}
	.botao button, .checkbox-arcos button {
		font-size: 14px;
	}
}
</style>
